// extracted by mini-css-extract-plugin
export default {"container":"Network_container__jlSjP","wrapper":"Network_wrapper__xdKBf"};